<script setup lang="ts">
import { computed } from "vue";
import { LayoutSelectorItemProps } from "@/cms/dialogs/LayoutSelector/LayoutSelector.types.ts";
import Checkmark from "@/cms/components/Checkmark/Checkmark.vue";

const props = defineProps<LayoutSelectorItemProps>();

const buttonClasses = computed(() => {
  const classes = [
    "border",
    "flex-col",
    "flex",
    "h-full",
    "hover:bg-gray-50",
    "hover:border-gray-300",
    "hover:shadow-sm",
    "hover:translate-y-[-1px]",
    "relative",
    "transition-all",
    "w-full",
    "transform-gpu",
    "focus-ring",
    "gap-2",
    "items-center",
    "justify-between",
  ];

  if (props.selected) {
    classes.push(
      "bg-green-50",
      "border-green-200",
      "hover:bg-green-50",
      "hover:border-green-200",
      "hover:shadow-none",
      "hover:translate-y-[0px]",
      "text-green-700",
      "cursor-default"
    );
  }

  return classes.join(" ");
});
</script>

<template>
  <button :class="buttonClasses" tabindex="0">
    <div
      v-if="layout.beta"
      class="absolute bg-gray-100 font-black h-auto p-2 right-4 rounded-xl select-none shadow text-black text-xs top-4 tracking-widest uppercase w-auto"
    >
      Beta
    </div>

    <img
      :src="layout.img"
      :alt="`Thumbnail for ${layout.title}`"
      class="h-auto m-auto object-contain p-2 rounded-md w-auto"
    />

    <div class="flex gap-3 items-center justify-center p-2 pt-0 w-full">
      <Checkmark v-if="selected" class="absolute bottom-1.5 h-6 left-2 w-6" />

      <p class="text-pretty text-sm">
        {{ layout.title }}
      </p>
    </div>
  </button>
</template>
